import Pagination from "../../entities/Pagination";
import {action, computed, makeObservable, observable, runInAction} from "mobx";
import {ClientService} from "../../service/ClientService";
import CommonStore from "../../stores/CommonStore";
import Client from "../../entities/Client";
import Agency from "../../entities/Agency";

class ClientStore {

    public clients: Client[];
    public pagination: Pagination;
    public filter?: string;
    public fromFilter: number | undefined;
    public toFilter: number | undefined;
    public agencyFilter?: Agency;
    public selectedClientIds: string[];
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore) {
        this.pagination = new Pagination(1, 15, 0, 0);
        this.clients = [];
        this.selectedClientIds = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            clients: observable,
            pagination: observable,
            selectedClientIds: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.clients.length === 0;
    }

    public setFilter(filer: string) {
        this.filter = filer;
    }

    public setFromFilter(from?: number) {
        this.fromFilter = from;
    }

    public setToFilter(to?: number) {
        this.toFilter = to;
    }

    get haveMoreThanOneSelected(): boolean {
        return this.selectedClientIds.length > 1;
    }

    @action
    public async search() {
        await this.getElements(1);
    }

    @action
    public async clearFilter() {
        this.agencyFilter = undefined;
        this.filter = undefined;
        this.fromFilter = undefined;
        this.toFilter = undefined;
        await this.getElements(1);
    }

    @action
    public async goToPage(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        await this.getElements(page, pageSize);
    }

    @action
    public async getElements(page: number = this.pagination.currentPage, pageSize: number = this.pagination.pageSize): Promise<void> {
        this.commonStore.setLoading();
        const response = await ClientService.get(page, pageSize, this.filter, this.agencyFilter?.id, this.fromFilter, this.toFilter);
        if (response.success) {
            runInAction(() => {
                this.clients = response.data?.data || [];
                this.pagination = response.data?.pagination || this.pagination;
            })
        }
        this.commonStore.processErrors(response);
        this.commonStore.removeLoading();
    }

}

export default ClientStore;